import React, { useState } from "react";
// * Icons ...
import { BsBookmarksFill } from "react-icons/bs";
import { ImBooks } from "react-icons/im";
import { CgMenuRightAlt, CgMenuLeftAlt } from "react-icons/cg";
import { FaUserCog } from "react-icons/fa";
// * Styles ...
import {
  Nav,
  NavbarContainer,
  NavLogo,
  UserLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  MobileNavItem,
  MobileNavLinks,
  MobileNavLogo,
  VerticalLine,
  SmallVerticalLine,
} from "./Navbar.elements";

const Navbar = () => {
  // * useState Operations ...
  const [click, setClick] = useState(false); // it determines the visibility of mobile menu should be visible or not. default value is false which make it hidden

  // * functions ...
  const handleClick = () => setClick(!click); // it opens and closes mobile menu
  const closeMobileMenu = () => setClick(false); // it only closes mobile menu

  return (
    <>
      <Nav>
        <NavbarContainer>
          {/* Navlogo settings ... */}
          <NavLogo to="/" onClick={closeMobileMenu}>
            <BsBookmarksFill />
          </NavLogo>
          {/* Mobile Menu Icon settings ... */}
          <MobileIcon onClick={handleClick}>
            {click ? <CgMenuLeftAlt /> : <CgMenuRightAlt />}
          </MobileIcon>
          {/* NavMenu settings ... */}
          <NavMenu onClick={handleClick} click={click}>
            {/* Mobile specefic configuration ... */}
            <MobileNavItem>
              <MobileNavLinks to="/Registeration">
                <MobileNavLogo>
                  <FaUserCog />
                </MobileNavLogo>
                حساب کاربری
              </MobileNavLinks>
            </MobileNavItem>
            <VerticalLine />
            <MobileNavItem>
              <MobileNavLinks>
                <MobileNavLogo>
                  <ImBooks />
                </MobileNavLogo>
                ژانر کتاب ها
              </MobileNavLinks>
            </MobileNavItem>
            <SmallVerticalLine />
            {/* shared mobile and desktop nav items ... */}
            <NavItem>
              <NavLinks to="/Stories" onClick={closeMobileMenu}>
                داستانی
              </NavLinks>
            </NavItem>
            <SmallVerticalLine />
            <NavItem>
              <NavLinks to="/Fantasies" onClick={closeMobileMenu}>
                فانتزی
              </NavLinks>
            </NavItem>
            <SmallVerticalLine />
            <NavItem>
              <NavLinks to="/Histories" onClick={closeMobileMenu}>
                تاریخی
              </NavLinks>
            </NavItem>
            <SmallVerticalLine />
            <NavItem>
              <NavLinks to="/Horrors" onClick={closeMobileMenu}>
                وحشت
              </NavLinks>
            </NavItem>
            <SmallVerticalLine />
            <NavItem>
              <NavLinks to="/Crimes" onClick={closeMobileMenu}>
                جنایی
              </NavLinks>
            </NavItem>
            <SmallVerticalLine />
          </NavMenu>
          {/* Desktop user icon ... */}
          <UserLogo to="/Registeration">
            <FaUserCog />
          </UserLogo>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
